// src/__internal__/shims/useTransition.ts
import React from "react";
var _a;
var useTransition = (_a = React.useTransition) != null ? _a : () => [false, (cb) => cb()];
export {
  useTransition
};
